import { Outlet } from "react-router-dom";
import {
  SimpleSidebarLayout,
  SimpleSidebarContent,
} from "@/core/components/ui/simple-sidebar";
import { useBusiness } from "@/core/business";
import {
  SpiffSidebarProvider,
  useSpiffSidebar,
} from "@/spiffs/context/spiff-sidebar-context";
import { SpiffSidebar } from "./common/spiff-sidebar";

const SpiffContent = () => {
  const { businessId } = useBusiness();
  const { state: sidebarState, updateSidebar } = useSpiffSidebar();

  return (
    <SimpleSidebarLayout
      open={sidebarState.isOpen}
      onOpenChange={(isOpen) => updateSidebar({ isOpen })}
    >
      <SimpleSidebarContent>
        <Outlet />
      </SimpleSidebarContent>
      <SpiffSidebar businessId={businessId} />
    </SimpleSidebarLayout>
  );
};

const Spiffs = () => (
  <SpiffSidebarProvider>
    <SpiffContent />
  </SpiffSidebarProvider>
);

export default Spiffs;
